<div #waveformContainer class="waveform" style="position: relative"
  [ngStyle]="{ background: trackRendered ? 'transparent' : 'linear-gradient(0deg, #000000 0%, #333333 49%, #000000 100%)' }">
</div>
